import { useIsAuthenticated } from '@heidi/auth/state';
import { type components } from '@heidi/schema/ml-scribe';
import { skipToken, useQuery } from '@tanstack/react-query';

import { GET_TEAM_MEMBER_ACCESS_ENTITLEMENTS } from '../../contracts/keys';
import { getTeamMemberAccessEntitlements } from '../api/entitlements';
import { getWorkspaceDataConfig } from '../config';

export type TeamMemberAccessEntitlementsListResponse =
  components['schemas']['TeamMemberAccessEntitlementsListResponse'];

/**
 * GET /api/v2/ml-scribe/access-entitlements/team/{team_id}/members
 * Caller must be a team admin.
 */
export function useQueryTeamMemberAccessEntitlements(teamId: string | undefined) {
  const { isAuthenticated } = useIsAuthenticated();

  return useQuery({
    queryKey: [GET_TEAM_MEMBER_ACCESS_ENTITLEMENTS, teamId],
    enabled: isAuthenticated && !!teamId,
    queryFn:
      isAuthenticated && teamId
        ? async () => {
            const { data } = await getTeamMemberAccessEntitlements(teamId);
            return data;
          }
        : skipToken,
  });
}

export async function invalidateTeamMemberAccessEntitlements(teamId: string) {
  await getWorkspaceDataConfig().queryClient.invalidateQueries({
    queryKey: [GET_TEAM_MEMBER_ACCESS_ENTITLEMENTS, teamId],
  });
}
